import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import GetStarted from '../../components/PublicSite/GetStarted';
import PublicSiteLayout from '../../components/PublicSite/PublicSiteLayout';
import { publicAccent, publicText } from '../../components/PublicSite/publicColors';
import { PRICING } from '../../utils/pageProse';

const Title = styled.h1`
  font-size: clamp(2rem, 4vw, 2.75rem);
  margin: 0 0 0.75rem;
`;

const Price = styled.p`
  font-size: 1.35rem;
  margin: 0 0 0.5rem;
`;

const Body = styled.p`
  color: ${publicText};
  line-height: 1.5;
  max-width: 36rem;
`;

const Back = styled(Link)`
  color: ${publicAccent};
`;

const PricingPage = (): JSX.Element => {
  return (
    <PublicSiteLayout>
      <Title>Pricing</Title>
      <Price>{PRICING.price}</Price>
      <Body>{PRICING.lock}</Body>
      <Body>
        {PRICING.plan} {PRICING.compare}
      </Body>
      <GetStarted source="pricing" idPrefix="pricing-waitlist" showPricingLink={false} />
      <p>
        <Back to="/">Back to Hesychia</Back>
      </p>
    </PublicSiteLayout>
  );
};

export default PricingPage;
